module.exports = __webpack_public_path__ + "static/media/loading1.ca0f3326.gif";